export const TAX_RATE = 0.14;
